
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden font-serif">
      {/* 背景画像 - 昭和レトロな雰囲気 */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/1e540445f75c9dcee344665fd01e733f.jpg)'
        }}
      />
      
      {/* 和紙風オーバーレイ - セピア・アンバートーン */}
      <div className="absolute inset-0 bg-gradient-to-b from-amber-900/70 via-stone-900/60 to-amber-900/70"></div>

      {/* 上部装飾ライン - 市松模様 */}
      <div className="absolute top-0 left-0 right-0 h-3 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-80"></div>
      <div className="absolute top-3 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-60"></div>

      {/* 下部装飾ライン - 市松模様 */}
      <div className="absolute bottom-3 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-60"></div>
      <div className="absolute bottom-0 left-0 right-0 h-3 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-80"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* タイトル装飾枠 */}
        <div className="relative inline-block mb-6">
          {/* 四隅装飾 */}
          <div className="absolute -top-3 -left-3 w-8 h-8 border-t-4 border-l-4 border-[#8b2500]"></div>
          <div className="absolute -top-3 -right-3 w-8 h-8 border-t-4 border-r-4 border-[#8b2500]"></div>
          <div className="absolute -bottom-3 -left-3 w-8 h-8 border-b-4 border-l-4 border-[#8b2500]"></div>
          <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-4 border-r-4 border-[#8b2500]"></div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white px-8 py-4">
            ◆ {t('management.hero.title')} ◆
          </h1>
        </div>

        {/* 金色装飾ライン */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-px w-24 bg-gradient-to-r from-transparent to-[#c9a84c]"></div>
          <span className="text-[#c9a84c] text-2xl">✦</span>
          <div className="h-px w-24 bg-gradient-to-l from-transparent to-[#c9a84c]"></div>
        </div>

        <p className="text-xl md:text-2xl text-[#c9a84c] mb-8 leading-relaxed">
          {t('management.hero.subtitle')}
        </p>

        <p className="text-lg text-stone-100 mb-12 max-w-2xl mx-auto leading-relaxed">
          {t('management.hero.description')}
        </p>

        {/* CTAボタン - 漆塗り風 */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#contact"
            className="group relative px-10 py-4 bg-gradient-to-b from-[#8b2500] to-[#6b1d00] text-white font-bold rounded-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-[#8b2500]/50 whitespace-nowrap"
          >
            {/* 上部金色装飾ライン */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent"></div>
            
            <span className="relative z-10 flex items-center justify-center gap-2">
              <span className="text-[#c9a84c]">✦</span>
              {t('management.hero.cta.contact')}
              <span className="text-[#c9a84c]">✦</span>
            </span>

            {/* 下部金色装飾ライン */}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent"></div>
            
            {/* ホバー時の光沢効果 */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"></div>
          </a>

          <a
            href="#pricing"
            className="px-10 py-4 bg-stone-100/10 backdrop-blur-sm text-white font-bold rounded-lg border-2 border-[#c9a84c] hover:bg-stone-100/20 transition-all duration-300 whitespace-nowrap"
          >
            {t('management.hero.cta.pricing')}
          </a>
        </div>

        {/* 装飾テキスト */}
        <div className="mt-12 text-[#c9a84c] text-sm tracking-widest">
          ━━━ 伝統と信頼の民泊管理 ━━━
        </div>
      </div>
    </section>
  );
}
